import ImageGalleryFullscreenCaption from './ImageGalleryFullscreenCaption';

export default ImageGalleryFullscreenCaption;
